<template>
  <div class="max-w-lg mx-auto text-center min-h-50">
    <div class="py-10 md:py-16 px-2 flex flex-col justify-between leading-normal">
      <div class="mb-2">
        <div class="text-gray-900 font-bold text-2xl mb-3 textColorRed" v-if="$route.query.result && $route.query.result === 'FAILURE'">Oops！訂單尚未付款成功喔</div>
        <div class="text-gray-900 font-bold text-2xl mb-3 textColorRed" v-else>感謝您的購買!</div>
      </div>

      <!-- 刷卡失敗 -->
      <div class="flex flex-wrap justify-center text-NotoSansBold items-center" v-if="$route.query.result && $route.query.result === 'FAILURE'">
        <p class="text-base textColorBlack" v-if="$route.query.ordernumber">訂單編號 {{ $route.query.ordernumber }} 已成立但刷卡未成功</p>
      </div>

      <!-- 刷卡成功/ATM轉帳 -->
      <div class="flex flex-wrap justify-center text-NotoSansBold items-center" v-else>
        <p class="text-base textColorBlack">訂單編號 {{ $route.query.ordernumber }} 已成立！</p>
        <div class="flex justify-center items-center">
          <p class="text-base textColorBlack">請前往</p>
            <router-link :to="{ name: 'order' }" class="text-sm mx-2 px-3 py-2 textColorDarkBlack orderCheckBtn btn--small popup__ok cursor-pointer hover:text-white text-NotoSansRegular"
              type="button">
              訂單查詢
            </router-link>
          <p class="text-base textColorBlack">查看</p>
        </div>
      </div>

      <div v-if="ATMpayment !== null" class="mt-6">
        <p>轉帳資料：</p>
        <p>銀行名稱： {{ ATMpayment.bankName }}</p>
        <p>繳費銀行代碼： {{ ATMpayment.bankCode }}</p>
        <p>繳費虛擬帳號： {{ ATMpayment.bankAccount }}</p>
        <p>繳款期限： {{ moment(ATMpayment.expired_at).format('YYYY/MM/DD, HH:mm:ss') }} 前</p>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'OrderFinish',
  props: {
    ATMpayment: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters([
      'authorized',
      'user'
    ])
  },
  mounted () {
    // this.init()
  },
  methods: {
    init () {
      let self = this
      if (!self.$route.query.ordernumber) {
        self.$router.push({ name: 'index' })
      } else {
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .orderCheckBtn {
    display: inline-block;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    height: auto;
    line-height: 1;
    background-color: white !important;
    border: 1px solid #9c9c9c;
    color: #434343;
    white-space: nowrap;
    transition: .3s;
    border-radius: 5px;
    &:hover {
      border: 1px solid #a0a0a0;
      background: #9c9c9c !important;
      color: white;
    }
  }
</style>
